var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui--content-heading" }, [
    _c("strong", { staticClass: "navbar-brand" }, [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
      _c(
        "ol",
        { staticClass: "breadcrumb float-right" },
        _vm._l(_vm.breadcrumb, function(item, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass: "breadcrumb-item",
              class: { active: item.active }
            },
            [_c("a", { attrs: { href: "#" } }, [_vm._v(_vm._s(item.text))])]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1750bf98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1750bf98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/markup/components/PubBreadcrumb.vue
// module id = null
// module chunks = 